import React from "react";

const YoutubeBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131589)">
      <path
        d="M26.2754 31.4545C19.4463 32.1831 12.559 32.1831 5.72994 31.4545C4.40379 31.3145 3.16571 30.7241 2.2221 29.7818C1.2785 28.8396 0.686386 27.6023 0.544482 26.2764C-0.184098 19.4473 -0.184098 12.56 0.544482 5.73091C0.684525 4.40476 1.2749 3.16668 2.21718 2.22308C3.15946 1.27947 4.39671 0.687362 5.72266 0.545458C12.5518 -0.183121 19.439 -0.183121 26.2681 0.545458C27.5943 0.685501 28.8323 1.27588 29.7759 2.21816C30.7196 3.16044 31.3117 4.39769 31.4536 5.72364C32.1821 12.5527 32.1821 19.44 31.4536 26.2691C31.3135 27.5952 30.7232 28.8333 29.7809 29.7769C28.8386 30.7205 27.6013 31.3126 26.2754 31.4545Z"
        fill="#E60000"
      />
      <path
        d="M25.5312 11.1891C25.1312 9.95821 23.8076 9.21275 22.5894 9.04184C18.2078 8.57638 13.7892 8.57638 9.40758 9.04184C8.1894 9.21275 6.86213 9.95094 6.46577 11.1891C5.84214 14.3667 5.84214 17.6352 6.46577 20.8128C6.86577 22.0418 8.1894 22.7891 9.40758 22.96C13.7892 23.4255 18.2078 23.4255 22.5894 22.96C23.8076 22.7891 25.1349 22.0509 25.5312 20.8128C26.1548 17.6352 26.1548 14.3667 25.5312 11.1891ZM13.6058 19.8328V12.1673L19.8458 16C17.7421 17.2928 15.7003 18.5455 13.6058 19.8328Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131589">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default YoutubeBrand1;
